import EncryptionUtils from "./encrypt";
import { START_LOADER, STOP_LOADER } from "./types";
import { USER_LOGIN_REFRESH_SUCCESS, USER_LOGOUT } from "./types/auth";

export const PROXY_PATH =
  process.env.REACT_APP_PROXY_PATH ||
  "/bajaj-proxy/BajajDitUat/SmartService.svc";

export const BASE_URL = (process.env.REACT_APP_API_URL || "") + PROXY_PATH;
// export const BASE_URL ="https://clientwebsitesuat2.kfintech.com/uatapi/bajaj-proxy/BajajDitUat/SmartService.svc";

export const FILE_URL =
  "https://transact.miraeassetmf.co.in/ktrackgo/SmartService.svc/ktrack_uploaded_PdfSave";
export const NCT_URL =
  "https://mfs.kfintech.com/prodapi/image-proxy/ktrackgo/SmartService.svc/ktrack_uploaded_PdfSave_NCT";
export const FEED_BACK_URL =
  "https://mfs.kfintech.com/KTRACKAPI/SmartService.svc";
export const CART_URL =
  process.env.REACT_APP_CART_API_URL ||
  "https://ditapp-uat.kfintech.com/api/ct";

var jwt = require("jsonwebtoken");

const FETCH_FAILED = "Failed to fetch";

const DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

async function invokeAPI(endpoint, config, auth_token) {
  const { isFile, isNct, isTrackApi, isCart, ...others } = config;
  const headers = !!auth_token
    ? { ...DEFAULT_HEADERS, authorization: `Bearer ${auth_token}` }
    : { ...DEFAULT_HEADERS };

  const updatedConfig = { ...others, headers };
  const response = await fetch(
    isNct
      ? NCT_URL
      : isFile
      ? FILE_URL
      : isCart
      ? CART_URL + endpoint
      : isTrackApi
      ? FEED_BACK_URL + endpoint
      : BASE_URL + endpoint,
    updatedConfig
  );
  // if (response.status < 200 || response.status >= 300) {
  //   //This is an error response.
  //   const data = await response.text();
  //   if (response.status == 413) {
  //     throw new Error(
  //       "Upload file size too large. Try uploading a smaller file less than 24 MB or change the file format."
  //     );
  //   }
  //   throw new Error("Something went wrong ");
  // }
  const responseData = await response.json();
  const { encryptedBody } = responseData;
  const data = encryptedBody
    ? JSON.parse(new EncryptionUtils().decrypt(encryptedBody))
    : responseData;
  // const body = JSON.parse(data);
  if (response.status >= 400) {
    console.log("response.status",response.status,data)
    throw new Error(
      data?.error === "Invalid User IdPassword"
        ? "Invalid User Id/Password"
        : data?.error || data?.message || "Something went wrong"
    );
  }
  

  const { Dtinformation, Table } = data;
  if (!!Dtinformation || !!Table) {
    const [info] = Dtinformation || Table;
    const errorCode = !!info
      ? typeof info.Error_code !== "undefined"
        ? info.Error_code
        : info.Error_Code
      : "";
    if (typeof errorCode === "undefined" && !!Dtinformation.length) {
      return data;
    } else if (+errorCode !== 0) {
      throw `${info.Error_Message}`;
    }
    return data;
  } else if (!!data || !!data.token) {
    return data;
  }
}

export const CALL_API = Symbol("Call API");

export const apiMiddleWare = (store) => (next) => async (action) => {
  // So the middleware doesn't get applied to every single action
  if (typeof action[CALL_API] === "undefined") {
    return next(action);
  }


  let {
    url,
    method,
    types = [],
    showLoader = false,
    body = undefined,
    params,
    ikyc = false,
    isNct = false,
    addedparams,
    isLogin = false,
    isCart = false,
    isFile = false,
    isTrackApi = false,
    skipEncode = false,
    newinvestor = false,
    isDistributorService = false
  } = action[CALL_API];

  const shouldEncrypt = () => {
    return !(isNct || isTrackApi || isFile || isCart || newinvestor || isDistributorService);
  }
  params = { ...params };
  const [requestType, successType] = types;

  const { authReducer } = store.getState();
  requestType && next({ type: requestType });
  try {
    if (showLoader) {
      next({ type: START_LOADER });
    }
    let prime_token = authReducer.auth_token;
    if (!!prime_token && !isLogin) {
      try {
        const { exp } = jwt.decode(prime_token);
        const diff = Math.floor(
          new Date(exp * 1000).getTime() - new Date().getTime()
        );
        if (diff < 0) {
          throw new Error(
            "Your active session has timeout. Request you to re-login"
          );
        }

        if (diff <= 20 * 60 * 1000) {
          const refresh = await invokeAPI(
            "/refresh_token",
            { method: "GET" },
            prime_token
          );
          if (!!refresh && !!refresh.token) {
            next({
              body: { ...refresh },
              type: USER_LOGIN_REFRESH_SUCCESS,
            });
            prime_token = refresh.token;
          } else {
            prime_token = authReducer.token;
            if (refresh.error == "jwt expired")
              throw new Error(
                "Your active session has timeout. Request you to re-login"
              );
          }
        }
      } catch (error) {
        next({
          type: USER_LOGOUT,
        });
        return;
      }
    }
    const queryParams = new URLSearchParams();
    for (let param in params) {
      if (skipEncode) {
        const value = params[param] || "";
        queryParams.set(param, encodeURIComponent(value));
      } else if (params[param]) {
        queryParams.set(param, encodeURIComponent(btoa(params[param])));
      }
    }

    const stringParametrs = queryParams.toString();
    const encryptedQueryString = new EncryptionUtils().encrypt(stringParametrs);
    const encryptedBody= new EncryptionUtils().encrypt(JSON.stringify(body));

    const responseBody = await invokeAPI(
      url +
        "?" +
        `encrypted=${shouldEncrypt()?encodeURIComponent(btoa(encryptedQueryString)):stringParametrs}&customfund=${encodeURIComponent(
          btoa("189")
        )}&Requid=${
          !!authReducer.userId
            ? encodeURIComponent(btoa(authReducer.userId))
            : ""
        }
        `,
      {
        method,
        body: shouldEncrypt()? (body? JSON.stringify({
          encrypted: encodeURIComponent(btoa(encryptedBody))
        }): undefined) :  JSON.stringify(body),
        redirect: "manual",
        isFile,
        isNct,
        isCart,
        isTrackApi,
      },
      authReducer.auth_token
    );
    const isValidLogin = validateLogin({
      isLogin,
      loginPayload: body,
      responseBody,
    });

    if (!isValidLogin) {
      next({ type: USER_LOGOUT });
      return;
    }

    successType &&
      next({
        body: { ...responseBody },
        type: successType,
      });

    return responseBody;
  } catch (error) {
    if (error.message !== FETCH_FAILED) {
      throw error;
    } else if (error.message === FETCH_FAILED) {
      console.log(error.message, "sdlfsdf");
    }
  } finally {
    if (showLoader) {
      next({ type: STOP_LOADER });
      //TODO: Dispatch hide modal loader now.
    }
  }
};

export default apiMiddleWare;
function validateLogin({ isLogin, loginPayload, responseBody }) {
  if (!isLogin) return true;
  const { username } = loginPayload;
  const { user, arn } = jwt.decode(responseBody.token);
  return decrypt(username) === user && arn === responseBody?.DtData[0]?.ARNCode;
}

function decrypt(text) {
  const decodedString = atob(text);
  const encrpyted1 = decodedString.slice(11, -16);
  const encrpyted = atob(encrpyted1);
  return encrpyted;
}
